@if ({ value: desktop$ | async }; as isDesktop) {
  @if (!isDesktop.value) {
    <div #backgroundCurtain class="background-curtain" (click)="isSidebarOpenService.toggleSidebar()"></div>
  }
}
<div #mainSideMenu class="d-flex flex-column flex-shrink-0 p-3 main-side-menu">
  @if ({ value: desktop$ | async }; as isDesktop) {
    @if (!isDesktop.value) {
      @if (siteConfig$ | async; as siteConfig) {
        @if (!siteConfig.ngConfig.primarySite) {
          <div class="mb-3 text-center">
            <a [href]="siteConfig.ngConfig.siteUrl">
              @if ({ value: isDarkMode$ | async }; as isDarkMode) {
                @if (isDarkMode.value) {
                  <img
                    style="height: 50px; max-width: 259px"
                    [src]="siteConfig.ngConfig.sideMenuImageDarkModeUrl"
                    [alt]="siteConfig.ngConfig.siteName"
                  />
                } @else {
                  <img
                    style="height: 50px; max-width: 250px"
                    [src]="siteConfig.ngConfig.sideMenuImageUrl"
                    [alt]="siteConfig.ngConfig.siteName"
                  />
                }
              }
            </a>
          </div>
        }
      }
    }
  }
  <app-locale-toggle></app-locale-toggle>
  @if (siteConfig$ | async; as siteConfig) {
    <div class="list-group mb-3">
      <a
        routerLink="/meet-list"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="list-group-item list-group-item-action"
      >
        <fa-icon class="me-2" [icon]="environment.icons.home" [fixedWidth]="true"></fa-icon>
        <span i18n="Meets Tab Title on the Main sidebar@@mainSidebar.meetsTabTitle">Meets</span>
      </a>
      <a
        routerLink="/about"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="list-group-item list-group-item-action"
      >
        <fa-icon class="me-2" [icon]="environment.icons.about" [fixedWidth]="true"></fa-icon>
        <span i18n="About Tab Title on the Main sidebar@@mainSidebar.aboutTabTitle">About</span>
      </a>
      <a
        routerLink="/contact"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="list-group-item list-group-item-action"
      >
        <fa-icon class="me-2" [icon]="environment.icons.help" [fixedWidth]="true"></fa-icon>
        <span i18n="Contact Us Tab Title on the Main sidebar@@mainSidebar.contactTabTitle">Contact Us</span>
      </a>

      @if (siteConfig.ngConfig.primarySite) {
        <a
          routerLink="pricing"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="list-group-item list-group-item-action"
        >
          <fa-icon class="me-2" [icon]="environment.icons.pricing" [fixedWidth]="true"></fa-icon>
          <span i18n="Features Tab Title on the Main sidebar@@mainSidebar.featuresTabTitle">Features & Pricing</span>
        </a>

        <a
          routerLink="athletic-field"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="list-group-item list-group-item-action"
        >
          <fa-icon class="me-2" [icon]="environment.icons.fieldApp" [fixedWidth]="true"></fa-icon>
          <span i18n="Get AthleticFIELD Tab Title on the Main sidebar@@mainSidebar.getAthleticFieldTabTitle"
            >Get AthleticFIELD</span
          >
        </a>
      } @else {
        <a href="https://live.athletic.net/pricing" class="list-group-item list-group-item-action">
          <fa-icon class="me-2" [icon]="environment.icons.pricing" [fixedWidth]="true"></fa-icon>
          <span i18n="Home Tab Title on the Main sidebar@@mainSidebar.featuresTabTitle2">Features & Pricing</span>
        </a>
        <a href="https://live.athletic.net/athletic-field" class="list-group-item list-group-item-action">
          <fa-icon class="me-2" [icon]="environment.icons.fieldApp" [fixedWidth]="true"></fa-icon>
          <span i18n="Home Tab Title on the Main sidebar@@mainSidebar.getAthleticFieldTabTitle2"
            >Get AthleticFIELD</span
          >
        </a>
      }

      @if (userRoles.includes('ROLE_ATHLETIC_SB')) {
        <a
          routerLink="athletic-sb-controller"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="list-group-item list-group-item-action"
        >
          <fa-icon class="me-2" [icon]="environment.icons.athleticSb" [fixedWidth]="true"></fa-icon>
          <span i18n="Home Tab Title on the Main sidebar@@mainSidebar.homeTabTitle">Manage AthleticSB</span>
        </a>
      }

      <div class="list-group-item list-group-item-action" style="cursor: pointer" (click)="onDarkModeToggle()">
        @if ({ value: isDarkMode$ | async }; as isDarkMode) {
          @if (isDarkMode.value) {
            <fa-icon class="me-2" [icon]="environment.icons.lightMode" [fixedWidth]="true"></fa-icon>
            <span i18n="Change to Light Mode on the Main sidebar@@mainSidebar.lightModeTabTitle">Light Mode</span>
          } @else {
            <fa-icon class="me-2" [icon]="environment.icons.darkMode" [fixedWidth]="true"></fa-icon>
            <span i18n="Change to Dark Mode on the Main sidebar@@mainSidebar.darkModeTabTitle">Dark Mode</span>
          }
        }
      </div>
    </div>
    <div ngbAccordion [destroyOnHide]="false" class="mb-3">
      <div ngbAccordionItem="enterprise" #enterprise="ngbAccordionItem" [collapsed]="!siteConfig.ngConfig.primarySite">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="justify-content-between">
            <span>
              @if (siteConfig.ngConfig.primarySite) {
                <ng-container i18n="Header introducing the ALive Enterprise Network@@mainSidebar.enterpriseNetwork"
                  >Enterprise Network</ng-container
                >
              } @else {
                {{ siteConfig.ngConfig.siteName }}
                <ng-container
                  i18n="Suffix explaining this timer is part of the EnterpriseNetwork@@mainSidebar.enterpriseNote"
                  >is part of the AthleticLIVE Enterprise Network</ng-container
                >.
              }
            </span>
            <fa-icon [icon]="enterprise.collapsed ? ['far', 'chevron-down'] : ['far', 'chevron-up']"></fa-icon>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody class="p-0">
            <ng-template>
              <div class="list-group list-group-flush">
                @for (site of environment.siteList; track site.machineName) {
                  <a
                    href="{{ site.link[0] }}"
                    target="_blank"
                    class="list-group-item list-group-item-action"
                    routerLinkActive="active"
                  >
                    <div class="d-flex align-items-center">
                      <div class="d-flex flex-shrink-0 justify-content-center me-2" style="flex-basis: 50px">
                        <div class="enterprise-network-logo">
                          <img
                            [ngSrc]="
                              (environment.production ? environment.cdnEndpoint : '') +
                              '/assets/sites/' +
                              site.machineName +
                              '/images/favicons/favicon-96x96.png'
                            "
                            width="40"
                            height="40"
                          />
                        </div>
                      </div>
                      <h6 class="mb-0">{{ site.name }}</h6>
                    </div>
                  </a>
                }
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  }
</div>
